import React from "react";
import {LoggerUtils} from "../../../../infrastructure/utils/logger/logger-utils";

export const UseErrorBoundaries = (Component) => class extends React.PureComponent {

  componentDidCatch(error, info) {
    const logger: LoggerUtils = this.props.ioc.getInstance(LoggerUtils);

    logger.error(error);
    logger.log(info);
  }

  render() {
    return <Component {...this.props} />
  }
}
